import React from 'react';

import theme from '$/assets/theme';
import Layout from '$/components/elements/Layout';
import Providers from '$/components/elements/Layout/Providers';
import SignInPage from '$/containers/SignInPage';

export interface ISignInPageProps {}

const SignIn = (props: ISignInPageProps) => (
  <Providers>
    <Layout {...props} background={theme.colors.brandGreen10} showFooter>
      <SignInPage {...props} page={'sign-in'} />
    </Layout>
  </Providers>
);

export default SignIn;
